<template>
  <section class="">
    <div
      class="px-4 mx-auto mt-6 max-w-5xl lg:px-0"
      :class="[
        paddingTop === 'reduced' ? 'pt-0' : 'pt-12 lg:pt-16',
        paddingBottom === 'reduced' ? 'pb-6 lg:pb-6' : 'pb-12 lg:pb-16'
      ]"
    >
      <div class="">
        <figure
          class="flex flex-col gap-4.5 items-center px-6 py-11 text-center rounded-xl bg-[#3B2314] sm:px-10 sm:py-12 lg:px-12 lg:pt-14 lg:pb-11"
        >
          <blockquote
            class="max-w-3xl italic font-serif text-22 leading-8 text-[#F5E2CB] sm:text-2xl sm:leading-9"
            v-html="quote"
          />

          <figcaption
            v-if="attribution"
            class="text-13 tracking-wide text-[#C8A882] uppercase font-ww-regular mt-3"
            v-html="attribution"
          />
        </figure>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  quote: {
    type: String,
    default: '"An ounce of prevention is worth a pound of cure. I will be 48 this year, and feel better now than I did in my thirties. Start small, build habits, and don\'t try to do everything at once."'
  },
  attribution: {
    type: String,
    default: '— Dr. Charles, CEO &amp; Founder, Lifeboost Coffee'
  },
  paddingTop: {
    type: String,
    default: 'reduced',
    validator: (value) => ['default', 'reduced'].includes(value)
  },
  paddingBottom: {
    type: String,
    default: 'reduced',
    validator: (value) => ['default', 'reduced'].includes(value)
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Master Quote',
  inputs: [
    {
      name: 'quote',
      type: 'richText',
      defaultValue: '"An ounce of prevention is worth a pound of cure. I will be 48 this year, and feel better now than I did in my thirties. Start small, build habits, and don\'t try to do everything at once."'
    },
    {
      name: 'attribution',
      type: 'text',
      defaultValue: '— Dr. Charles, CEO & Founder, Lifeboost Coffee'
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    }
  ]
})
</script>
